export default __webpack_public_path__ + "static/media/Retiree2.c5900a76.png";